import React from 'react';
import Plot from 'react-plotly.js';

function BoxPlot(values) {
  return (
    <div className="overflow-hidden mx-auto max-w-2xl shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
      <Plot
        data={[
          {
            q1: [values.data.q1],
            median: [values.data.mean],
            q3: [values.data.q3],
            mean: [values.data.mean],
            lowerfence: [values.data.min],
            upperfence: [values.data.max],
            // y: values.data,
            type: 'box',
            marker: { color: '#374151'}
          },
        ]}
        layout={{ 
          width: 640, 
          height: 480, 
          xaxis: {
            tickformat: ":04,2f"
          },
          yaxis: {
            tickformat: ":04,2f"
          }
        }}
      />
    </div>

  );
}

export default BoxPlot;
